class DomHelper{
    
    findNodeUpper(ele:any, tag:any){
        if (ele.parentNode) {
            if (ele.parentNode.tagName === tag.toUpperCase()) {
            return ele.parentNode
            } else {
            return this.findNodeUpper(ele.parentNode, tag)
            }
        }
    }
  
    findNodeUpperByClasses(ele: { parentNode: any }, classes: any[]){
        let parentNode = ele.parentNode
        if (parentNode) {
            let classList = parentNode.classList
            if (classList && classes.every(className => classList.contains(className))) {
                return parentNode
            } else {
                return this.findNodeUpperByClasses(parentNode, classes)
            }
        }
    }
  
    findNodeDownward(ele: { childNodes: string | any[] }, tag: string){
        const tagName = tag.toUpperCase()
        if (ele.childNodes.length) {
            let i = -1
            let len = ele.childNodes.length
            while (++i < len) {
                let child = ele.childNodes[i]
                if (child.tagName === tagName) return child
                else return this.findNodeDownward(child, tag)
            }
        }
    }

    
    /**
     * @description 绑定事件 on(element, event, handler)
     */
    on = (function () {
        if (document.addEventListener) {
        return function (element, event, handler) {
            if (element && event && handler) {
            element.addEventListener(event, handler, false)
            }
        }
        } else {
        return function (element, event, handler) {
            if (element && event && handler) {
            element.attachEvent('on' + event, handler)
            }
        }
        }
    })()
  
    /**
     * @description 解绑事件 off(element, event, handler)
     */
    off = (function () {
        if (document.removeEventListener) {
        return function (element, event, handler) {
            if (element && event) {
            element.removeEventListener(event, handler, false)
            }
        }
        } else {
        return function (element, event, handler) {
            if (element && event) {
            element.detachEvent('on' + event, handler)
            }
        }
        }
    })()
  
    // scrollTop animation
    scrollTop = (el, from = 0, to, duration = 500, endCallback?:any) => {
        let win = window as any;
        if (!win.requestAnimationFrame) {
            win.requestAnimationFrame = (
                win.webkitRequestAnimationFrame ||
                win.mozRequestAnimationFrame ||
                win.msRequestAnimationFrame ||
            function (callback) {
                return window.setTimeout(callback, 1000 / 60)
            }
        )
        }
        const difference = Math.abs(from - to)
        const step = Math.ceil(difference / duration * 50)
    
        const scroll = (start, end, step) => {
        if (start === end) {
            endCallback && endCallback()
            return
        }
    
        let d = (start + step > end) ? end : start + step
        if (start > end) {
            d = (start - step < end) ? end : start - step
        }
    
        if (el === window) {
            window.scrollTo(d, d)
        } else {
            el.scrollTop = d
        }
        window.requestAnimationFrame(() => scroll(d, end, step))
        }
        scroll(from, to, step)
    }

    downloadFile(data:any, name:string) {
        if (!data) {
            return;
        }

        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", name);

        document.body.appendChild(link);
        link.click();
    }
}

export const domHelper = new DomHelper()
